import {
  degreeDaysInsectIds,
  larvalTrendInsectIds,
  phenologyInsectIds,
  trapCatchesInsectIds,
} from './insectValueGroupIds'

export const recordByInsectId =
  <TPrefix extends string, TInsectId extends number>(prefix: TPrefix, insectIds: readonly TInsectId[]) =>
  <TValue>(valueFor: (insectId: TInsectId, valueGroup: `${TPrefix}${TInsectId}`) => TValue) =>
    // Object.fromEntries types its keys as string. Every key is the prefix plus one id from the list, so this type is exact
    Object.fromEntries(
      insectIds.map((insectId) => {
        const valueGroup = `${prefix}${insectId}` as const

        return [valueGroup, valueFor(insectId, valueGroup)] as const
      }),
    ) as Record<`${TPrefix}${TInsectId}`, TValue>

export const degreeDaysRecord = recordByInsectId('degree_days_insect_id_', degreeDaysInsectIds)

export const trapCatchesRecord = recordByInsectId('trap_catches_insect_id_', trapCatchesInsectIds)

export const larvalTrendRecord = recordByInsectId('larval_trend_insect_id_', larvalTrendInsectIds)

export const phenologyRecord = recordByInsectId('phenology_insect_id_', phenologyInsectIds)
